// Development Environment
// const API_URL = process.env.REACT_APP_DEVELOPMENT_API_URL;
// const ACTUAL_IMAGE_URL = process.env.REACT_APP_DEVELOPMENT_ACTUAL_IMAGE_URL;
// const COMPRESSED_IMAGE_URL = process.env.REACT_APP_DEVELOPMENT_COMPRESSED_IMAGE_URL;

// Deployed Environment
const API_URL = process.env.REACT_APP_DEPLOYED_API_URL;
const ACTUAL_IMAGE_URL = process.env.REACT_APP_DEPLOYED_ACTUAL_IMAGE_URL;
const COMPRESSED_IMAGE_URL = process.env.REACT_APP_DEPLOYED_COMPRESSED_IMAGE_URL;

const DROPDOWN_FLAG = {
	ADMIN: process.env.REACT_APP_ADMIN_FLAG,
	USER: process.env.REACT_APP_USER_FLAG,
	PRODUCT: process.env.REACT_APP_PRODUCT_FLAG,
	COLOR: process.env.REACT_APP_COLOR_FLAG,
	CATEGORY: process.env.REACT_APP_CATEGORY_FLAG,
	SUBCATEGORY: process.env.REACT_APP_SUBCATEGORY_FLAG,
	PRODUCT_DESCRIPTION: process.env.REACT_APP_PRODUCT_DESCRIPTION_FLAG,
	SIZE: process.env.REACT_APP_SIZE_FLAG,
	ARTICLE_CODE: process.env.REACT_APP_ARTICLE_CODE_FLAG,
};

module.exports = {
	API_URL,
	ACTUAL_IMAGE_URL,
	COMPRESSED_IMAGE_URL,
	DROPDOWN_FLAG,
};
